// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgConnectedArrowsDouble = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.876 9.018a.685.685 0 0 1-.936 0 .61.61 0 0 1 0-.893l2.4-2.29h-1.005V4.572h1.005l-2.4-2.29a.61.61 0 0 1 0-.894.685.685 0 0 1 .936 0l3.53 3.369a.61.61 0 0 1 0 .893zM9.214 4.572h1.061v1.263H9.214zm-1.06 0v1.263H7.096V4.572zm-2.117 0h-1.06v1.263h1.06zM3.918 5.835V4.572H2.463c-.366 0-.662.282-.662.631s.296.632.662.632zm1.607 1.537a.685.685 0 0 1 .936 0 .61.61 0 0 1 0 .894l-2.401 2.29h1.006v1.263H4.06l2.4 2.29a.61.61 0 0 1 0 .893.685.685 0 0 1-.935 0l-3.531-3.368a.61.61 0 0 1 0-.893l3.53-3.369Zm1.662 4.447H6.125v-1.263h1.062zm2.117 0H8.246v-1.263h1.058zm1.06 0h1.06v-1.263h-1.06zm2.118 0h1.456c.365 0 .662-.283.662-.632 0-.348-.297-.631-.662-.631h-1.456z"
    />
  </svg>
);
export const ConnectedArrowsDoubleIcon = forwardRef(SvgConnectedArrowsDouble);
